var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClocktick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.3332 25.3333L21.9998 28L27.9998 22M29.3133 16.7332C29.3265 16.4904 29.3332 16.246 29.3332 16C29.3332 8.63619 23.3636 2.66666 15.9998 2.66666C8.63604 2.66666 2.6665 8.63619 2.6665 16C2.6665 23.2472 8.44852 29.144 15.6512 29.3288M15.9998 7.99999V16L20.9844 18.4923",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClocktick);
export default __webpack_public_path__ + "static/media/clocktick.9e30faef19af40cf734da0640d8c5fe2.svg";
export { ForwardRef as ReactComponent };